import React, { Component, Fragment } from 'react'
import { GlgCheckbox, GlgSelect, GlgTooltipIcon } from 'SharedComponents'
import { Row, Col } from 'react-flexbox-grid'
import { FormControl } from 'react-bootstrap'
import PropTypes from 'prop-types'

const EventsScopeComponent = (props) => {
  const triggerType = Object.keys(props.trigger)[0]

  return (
    <Fragment>
      <Col className='no-padding add-margin-top-10 add-margin-bottom-10 vertical-align col-xs-offset-1 col-md-offset-0' xs={ 12 } sm={ 6 } md={ 5 } lg={ 4 }>
        <div className='radio btsp_radio radio-primary no-margin'>
          <input
            type="radio"
            name="triggers[radio]"
            value="allEvents"
            checked={props.trigger[triggerType].events === 'allEvents'}
            onChange={props.setTriggerEvents(triggerType, 'allEvents')}
            id="allEvents" />
          <label htmlFor="allEvents">
            <span>
              { window.I18n.t('marketing_campaigns.components.triggers_component.all_events') }
            </span>
          </label>
        </div>
        <div className='radio btsp_radio radio-primary no-margin'>
          <input
            type="radio"
            name="triggers[radio]"
            value="selectedEvents"
            checked={ props.trigger[triggerType].events.constructor === Array }
            onChange={ props.setTriggerEvents(triggerType, []) }
            id="selectedEvents" />
          <label htmlFor="selectedEvents">
            <span>
              { window.I18n.t('marketing_campaigns.components.triggers_component.selected_events') }
            </span>
          </label>
        </div>
      </Col>
      { props.trigger[triggerType].events.constructor === Array && (
        <Col className='vertical-align col-md-offset-4 col-lg-offset-0 col-xs-offset-1 no-padding-left' xs={ 12 } sm={ 12 } md={ 8 } lg={ 4 }>
          <GlgSelect
            className='multi-select'
            items={ props.leagueCategories }
            isMulti={ true }
            defaultValue={ props.trigger[triggerType].events }
            onChange={ props.setTriggerEvents(triggerType) } />
        </Col>
      )}
    </Fragment>
  )
}

class TriggersComponent extends Component {

  render(){
    const {
      leagueCategories,
      triggers: {
        registrationOpensIn,
        registrationRecentlyOpened,
        registrationBelowTarget,
        registrationAlmostFull,
        registrationClosesIn,
        afterEventEnd,
        afterRoundEnd,
      },
      toggleTrigger,
      setTriggerDays,
      setTriggerPercentage,
      setTriggerEvents,
      toggleTriggerPauseEvaluation,
      setTriggerPauseEvaluationDays,
      textMessageChannelChecked,
    } = this.props

    return (
      <div className='triggers-component'>
        <p className='add-margin-top-10'>
          { window.I18n.t('marketing_campaigns.components.triggers_component.promote_events') }
        </p>
        <Row>
          <Col className='revert-grid' xs={ 12 }>
            <Row className='vertical-align add-margin-top-5 trigger-option'>
              <Col className='revert-grid' xs={ 8 } sm={ 4 } md={ 3 }>
                <div className='radio btsp_radio radio-primary no-margin'>
                  <input
                    type="radio"
                    name="trigger_type[radio]"
                    value="registrationOpensIn"
                    checked={registrationOpensIn.checked}
                    onChange={toggleTrigger('registrationOpensIn')}
                    id="registrationOpensIn" />
                  <label htmlFor="registrationOpensIn">
                    <span>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.registration_opens') }
                    </span>
                  </label>
                </div>
              </Col>
              {registrationOpensIn.checked && (
                <Fragment>
                  <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } md={ 1 } lg={ 1 }>
                    <FormControl
                      className='small_box'
                      type="text"
                      name="triggers[registration_opens_in_days]"
                      defaultValue={ registrationOpensIn.days }
                      onChange={ (e) => { setTriggerDays('registrationOpensIn', e.target.value) } }
                      autoFocus={ true } />
                    { window.I18n.t('marketing_campaigns.components.triggers_component.days') }
                  </Col>
                  <EventsScopeComponent
                    trigger={ {registrationOpensIn: registrationOpensIn} }
                    leagueCategories={ leagueCategories }
                    setTriggerEvents={ setTriggerEvents } />
                </Fragment>
              )}
            </Row>
            <Row className='vertical-align add-margin-top-5 trigger-option'>
              <Col className='revert-grid' xs={ 8 } sm={ 4 } lg={ 3 }>
                <div className='radio btsp_radio radio-primary no-margin'>
                  <input
                    type="radio"
                    name="trigger_type[radio]"
                    value="registrationRecentlyOpened"
                    checked={registrationRecentlyOpened.checked}
                    onChange={toggleTrigger('registrationRecentlyOpened')}
                    id="registrationRecentlyOpened" />
                  <label htmlFor="registrationRecentlyOpened">
                    <span>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.registration_opened') }
                    </span>
                  </label>
                </div>
              </Col>
              {registrationRecentlyOpened.checked && (
                <Fragment>
                  <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } md={ 1 }>
                    <FormControl
                      className='small_box'
                      type="text"
                      name="triggers[registration_recently_opened]"
                      defaultValue={ registrationRecentlyOpened.days }
                      onChange={ (e) => { setTriggerDays('registrationRecentlyOpened', e.target.value) } }
                      autoFocus={ true } />
                    <div className='add-margin-left-5'>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.days') }
                    </div>
                  </Col>
                  <EventsScopeComponent
                    trigger={ {registrationRecentlyOpened: registrationRecentlyOpened} }
                    leagueCategories={ leagueCategories }
                    setTriggerEvents={ setTriggerEvents } />
                </Fragment>
              )}
            </Row>
            <Row className='vertical-align add-margin-top-5 trigger-option'>
              <Col xs={ 8 } sm={ 4 } lg={ 3 }>
                <div className='radio btsp_radio radio-primary no-margin'>
                  <input
                    type="radio"
                    name="trigger_type[radio]"
                    value="registrationBelowTarget"
                    checked={registrationBelowTarget.checked}
                    onChange={toggleTrigger('registrationBelowTarget')}
                    id="registrationBelowTarget" />
                  <label htmlFor="registrationBelowTarget">
                    <span>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.registration_below') }
                    </span>
                  </label>
                </div>
              </Col>
              {registrationBelowTarget.checked && (
                <Fragment>
                  <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } md={ 1 }>
                    <FormControl
                      className='small_box'
                      type="text"
                      name="triggers[registration_is_below]"
                      defaultValue={ registrationBelowTarget.percentage }
                      onChange={ (e) => { setTriggerPercentage('registrationBelowTarget', e.target.value) } }
                      autoFocus={ true } />
                    {'%'}
                  </Col>
                  <EventsScopeComponent
                    trigger={ {registrationBelowTarget: registrationBelowTarget} }
                    leagueCategories={ leagueCategories }
                    setTriggerEvents={ setTriggerEvents } />
                </Fragment>
              )}
              {registrationBelowTarget.checked && (
                <Col className='vertical-align col-md-offset-0 col-lg-offset-0 col-xs-offset-1 add-padding-left-40' xs={ 12 }>
                  <GlgCheckbox
                    label={ window.I18n.t('marketing_campaigns.components.triggers_component.single_message') }
                    name="triggers[checkbox]"
                    checked={ registrationBelowTarget.pauseEvaluation.checked }
                    onChange={ toggleTriggerPauseEvaluation('registrationBelowTarget') } />
                  <FormControl
                    className='width-70 add-margin-left-5 add-margin-right-5'
                    type="text"
                    name="triggers[registration_is_below]"
                    defaultValue={ registrationBelowTarget.pauseEvaluation.days }
                    onChange={ (e) => { setTriggerPauseEvaluationDays('registrationBelowTarget', e.target.value) } } />
                  { window.I18n.t('marketing_campaigns.components.triggers_component.days') }          
                </Col>
              )}
            </Row>
            <Row className='vertical-align add-margin-top-5 trigger-option'>
              <Col className='revert-grid' xs={ 8 } sm={ 4 } lg={ 3 }>
                <div className='radio btsp_radio radio-primary no-margin'>
                  <input
                    type="radio"
                    name="trigger_type[radio]"
                    value="registrationAlmostFull"
                    checked={registrationAlmostFull.checked}
                    onChange={toggleTrigger('registrationAlmostFull')}
                    id="registrationAlmostFull" />
                  <label htmlFor="registrationAlmostFull">
                    <span>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.registration_full') }
                    </span>
                  </label>
                </div>
              </Col>
              {registrationAlmostFull.checked && (
                <Fragment>
                  <Col className='vertical-align no-padding' xs={ 4 } sm={ 2 } md={ 1 }>
                    <FormControl
                      className='small_box'
                      type="text"
                      name="triggers[registration_almost_full]"
                      defaultValue={ registrationAlmostFull.percentage }
                      onChange={ (e) => { setTriggerPercentage('registrationAlmostFull', e.target.value) } }
                      autoFocus={ true } />
                    {'%'}
                  </Col>
                  <EventsScopeComponent
                    trigger={ {registrationAlmostFull: registrationAlmostFull} }
                    leagueCategories={ leagueCategories }
                    setTriggerEvents={ setTriggerEvents } />
                </Fragment>
              )}
              {registrationAlmostFull.checked && (
                <Col className='vertical-align col-md-offset-0 col-lg-offset-0 col-xs-offset-1 add-padding-left-40' xs={ 12 }>
                  <GlgCheckbox
                    label={ window.I18n.t('marketing_campaigns.components.triggers_component.single_message') }
                    name="triggers[checkbox]"
                    checked={ registrationAlmostFull.pauseEvaluation.checked }
                    onChange={ toggleTriggerPauseEvaluation('registrationAlmostFull') } />
                  <FormControl
                    className='width-70 add-margin-left-5add-margin-right-5'
                    type="text"
                    name="triggers[registration_is_below]"
                    defaultValue={ registrationAlmostFull.pauseEvaluation.days }
                    onChange={ (e) => { setTriggerPauseEvaluationDays('registrationAlmostFull', e.target.value) } } />
                  { window.I18n.t('marketing_campaigns.components.triggers_component.days') }
                </Col>
              )}
            </Row>
            <Row className='vertical-align add-margin-bottom-5 trigger-option'>
              <Col xs={ 8 } sm={ 4 } lg={ 3 }>
                <div className='radio btsp_radio radio-primary no-margin'>
                  <input
                    type="radio"
                    name="trigger_type[radio]"
                    value="registrationClosesIn"
                    checked={registrationClosesIn.checked}
                    onChange={toggleTrigger('registrationClosesIn')}
                    id="registrationClosesIn" />
                  <label htmlFor="registrationClosesIn">
                    <span>
                      { window.I18n.t('marketing_campaigns.components.triggers_component.registration_closes') }
                    </span>
                  </label>
                </div>
              </Col>
              {registrationClosesIn.checked && (
                <Fragment>
                  <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } lg={ 1 }>
                    <FormControl
                      className='small_box'
                      type="text"
                      name="triggers[registration_closes_in]"
                      defaultValue={ registrationClosesIn.days }
                      onChange={ (e) => { setTriggerDays('registrationClosesIn', e.target.value) } }
                      autoFocus={ true } />
                    { window.I18n.t('marketing_campaigns.components.triggers_component.days') }
                  </Col>
                  <EventsScopeComponent
                    trigger={ {registrationClosesIn: registrationClosesIn} }
                    leagueCategories={ leagueCategories }
                    setTriggerEvents={ setTriggerEvents } />
                </Fragment>
              )}
            </Row>
            { !textMessageChannelChecked && (
              <Fragment>
                <Row className='vertical-align add-margin-bottom-5 trigger-option'>
                  <Col xs={ 8 } sm={ 4 } lg={ 3 }>
                    <div className='radio btsp_radio radio-primary no-margin'>
                      <input
                        type="radio"
                        name="trigger_type[radio]"
                        value="afterEventEnd"
                        checked={ afterEventEnd.checked }
                        onChange={toggleTrigger('afterEventEnd')}
                        id="afterEventEnd" />
                      <label htmlFor="afterEventEnd">
                        <span>
                          { window.I18n.t('marketing_campaigns.components.triggers_component.event_ended') }
                        </span>
                      </label>
                      <GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.triggers_component.trigger_event_roster_tooltip') } />
                    </div>
                  </Col>
                  {afterEventEnd.checked && (
                    <Fragment>
                      <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } lg={ 1 }>
                        <FormControl
                          className='small_box'
                          type="text"
                          name="triggers[after_event_end]"
                          defaultValue={ afterEventEnd.days }
                          onChange={ (e) => {
                            setTriggerDays('afterEventEnd', e.target.value)
                          }}
                          autoFocus={ true } />
                        {window.I18n.t('marketing_campaigns.components.triggers_component.days')}
                      </Col>
                      <EventsScopeComponent
                        trigger={ {afterEventEnd: afterEventEnd} }
                        leagueCategories={ leagueCategories }
                        setTriggerEvents={ setTriggerEvents } />
                    </Fragment>
                  )}
                </Row>
                <Row className='vertical-align add-margin-bottom-5 trigger-option'>
                  <Col xs={ 8 } sm={ 4 } lg={ 3 }>
                    <div className='radio btsp_radio radio-primary no-margin'>
                      <input
                        type="radio"
                        name="trigger_type[radio]"
                        value="afterRoundEnd"
                        checked={ afterRoundEnd.checked }
                        onChange={toggleTrigger('afterRoundEnd')}
                        id="afterRoundEnd" />
                      <label htmlFor="afterRoundEnd">
                        <span>
                          { window.I18n.t('marketing_campaigns.components.triggers_component.round_ended') }
                        </span>
                      </label>
                      <GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.triggers_component.trigger_event_roster_tooltip') } />
                    </div>
                  </Col>
                  {afterRoundEnd.checked && (
                    <Fragment>
                      <Col className='no-padding vertical-align' xs={ 4 } sm={ 2 } lg={ 1 }>
                        <FormControl
                          className='small_box'
                          type="text"
                          name="triggers[after_round_end]"
                          defaultValue={ afterRoundEnd.days }
                          onChange={ (e) => {
                            setTriggerDays('afterRoundEnd', e.target.value)
                          } }
                          autoFocus={ true } />
                        {window.I18n.t('marketing_campaigns.components.triggers_component.days')}
                      </Col>
                      <EventsScopeComponent
                        trigger={ {afterRoundEnd: afterRoundEnd} }
                        leagueCategories={ leagueCategories }
                        setTriggerEvents={ setTriggerEvents } />
                    </Fragment>
                  )}
                </Row>
              </Fragment>
            )}
          </Col>
        </Row>
      </div>
    )
  }
}

EventsScopeComponent.propTypes = {
  trigger: PropTypes.oneOfType([
    PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    PropTypes.shape({
      checked: PropTypes.bool,
      percentage: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
      pauseEvaluation: PropTypes.shape({
        checked: PropTypes.bool,
        days: PropTypes.string,
      }),
    }),
  ]).isRequired,
  leagueCategories: PropTypes.array.isRequired,
  setTriggerEvents: PropTypes.func.isRequired,
}

TriggersComponent.propTypes = {
  triggers: PropTypes.shape({
    registrationOpensIn: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    registrationRecentlyOpened: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    registrationBelowTarget: PropTypes.shape({
      checked: PropTypes.bool,
      percentage: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
      pauseEvaluation: PropTypes.shape({
        checked: PropTypes.bool,
        days: PropTypes.string,
      }),
    }),
    registrationAlmostFull: PropTypes.shape({
      checked: PropTypes.bool,
      percentage: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
      pauseEvaluation: PropTypes.shape({
        checked: PropTypes.bool,
        days: PropTypes.string,
      }),
    }),
    registrationClosesIn: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    afterEventEnd: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
    afterRoundEnd: PropTypes.shape({
      checked: PropTypes.bool,
      days: PropTypes.string,
      events: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
      ]),
    }),
  }),
  textMessageChannelChecked: PropTypes.bool.isRequired,
  leagueCategories: PropTypes.array.isRequired,
  toggleTrigger: PropTypes.func.isRequired,
  setTriggerDays: PropTypes.func.isRequired,
  setTriggerPercentage: PropTypes.func.isRequired,
  setTriggerEvents: PropTypes.func.isRequired,
  toggleTriggerPauseEvaluation: PropTypes.func.isRequired,
  setTriggerPauseEvaluationDays: PropTypes.func.isRequired,
}

export default TriggersComponent
